import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';

const classes = new Bem('tabButton');

export default class TabButton extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.any.isRequired, // eslint-disable-line
    htmlFor: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
  };

  /*  static componentCacheConfig = {
    strategy: 'template',
    enable: true
  }; */

  render() {
    const { className, children } = this.props;
    const title = children.button.props;
    const after = children.after ? children.after.props : children.after;
    const icon = children.icon ? children.icon.props : children.icon;

    return (
      <label //eslint-disable-line
        {...classes({
          extra: className
        })}
        id={`label_${this.props.id}`}
        htmlFor={this.props.htmlFor}
        onClick={e => e.preventDefault()}
      >
        <span {...classes('btnContent')}>
          {icon && icon.children}
          <span {...classes('text')}>
            {title.children}
          </span>
          {after && (
            <span {...classes('afterContainer')}>
              <span {...classes('after')}>
                {after.children}
              </span>
            </span>
          )}
        </span>
        <span {...classes('line')} />
      </label>
    );
  }
}
